import {
  REBOOK_FETCH_DATA_REQUEST, REBOOK_FETCH_DATA_SUCCESS, REBOOK_FETCH_DATA_FAILURE
} from "./constants";

export const rebookRequest = () => ({
  type: REBOOK_FETCH_DATA_REQUEST
});

export const rebookSuccess = (payload) => ({
  type: REBOOK_FETCH_DATA_SUCCESS,
  payload
});

export const rebookFailure = (error) => ({
  type: REBOOK_FETCH_DATA_FAILURE,
  payload: { error }
});

